<template>
    <div class="create-button-container">
       <p>{{title}}</p>
    </div>
</template>

<script>
    export default {
        props: {
            title: ''
        },
        data () {
            return {

            }
        },
        computed: {

        },
        methods: {

        }
    }
</script>

<style lang="scss">
@import "../css/constants";
.tab-bar {
    margin-bottom: 0rem;
}
p {
  line-height: 75px;
  font-size: $p16;
  color:grey;
}
  .create-button-container{
    height:75px;
    width: 140%;
    overflow:hidden;
    background-color:white;
    margin-left: -1.5rem;
    padding-left: 26px;
    border-top: 1px solid #cfcfcf;


  }

</style>


// WEBPACK FOOTER //
// src/components/CreateCaption.vue